import { render, staticRenderFns } from "./GameBubbles.vue?vue&type=template&id=a76cb3ae&scoped=true&"
import script from "./GameBubbles.vue?vue&type=script&lang=js&"
export * from "./GameBubbles.vue?vue&type=script&lang=js&"
import style0 from "./GameBubbles.vue?vue&type=style&index=0&id=a76cb3ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76cb3ae",
  null
  
)

export default component.exports